function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import moment from 'moment';
import { createSelector } from 'reselect';
import * as c from './constants';
var initialState = {
  availablePlagiarismPurchases: [],
  plagiarismPurchase: null,
  plagiarisms: [],
  hasPlagiarismPurchase: false,
  hasUploadedPlagiarism: true,
  pagination: {},
  processingDocuments: {},
  status: {
    downloadingFiles: [],
    retrievingDownload: false,
    searchBusy: false,
    searchCompleted: false
  }
};
var plagiarismColor = function plagiarismColor(plagiarism) {
  switch (plagiarism.status) {
    case c.STATUSES.STATUS_GENERATED:
      return '#42b22b';
    case c.STATUSES.STATUS_FAILED:
      return '#b4172b';
    default:
      return '#d6d6d6';
  }
};
export var getPlagiarisms = createSelector(function (_ref) {
  var plagiarism = _ref.plagiarism;
  return (plagiarism === null || plagiarism === void 0 ? void 0 : plagiarism.plagiarisms) || [];
}, function (_ref2) {
  var plagiarism = _ref2.plagiarism;
  return (plagiarism === null || plagiarism === void 0 ? void 0 : plagiarism.processingDocuments) || {};
}, function (plagiarisms, processingDocuments) {
  return plagiarisms.map(function (plagiarism) {
    return _objectSpread(_objectSpread({}, plagiarism), {}, {
      identity: plagiarism.id,
      color: plagiarismColor(plagiarism),
      completed: plagiarism.status === c.STATUSES.STATUS_GENERATED,
      finishedProcessing: plagiarism.status !== c.STATUSES.STATUS_INITIALIZED,
      failed: plagiarism.status === c.STATUSES.STATUS_FAILED,
      processing: plagiarism.status === c.STATUSES.STATUS_PROCESSING || processingDocuments[plagiarism.fileIdentity],
      createdAt: moment(plagiarism.createdAt.date).format('YYYY-MM-DD'),
      fileType: "file-type-".concat(plagiarism.fileName.split('.').pop().toLowerCase())
    });
  });
});
export var getProcessingDocuments = createSelector(function (_ref3) {
  var plagiarism = _ref3.plagiarism;
  return (plagiarism === null || plagiarism === void 0 ? void 0 : plagiarism.processingDocuments) || {};
}, function (processingDocuments) {
  return processingDocuments;
});
export var getPlagiarismStatus = createSelector(function (_ref4) {
  var plagiarism = _ref4.plagiarism;
  return (plagiarism === null || plagiarism === void 0 ? void 0 : plagiarism.status) || {
    downloadingFiles: [],
    retrievingDownload: false,
    searchBusy: false,
    searchCompleted: false
  };
}, function (status) {
  return status;
});
export var getPlagiarism = createSelector(getPlagiarisms, function (_ref5) {
  var _match$params;
  var match = _ref5.match;
  return match === null || match === void 0 || (_match$params = match.params) === null || _match$params === void 0 ? void 0 : _match$params.identity;
}, function (plagiarisms, identity) {
  return plagiarisms.find(function (plagiarism) {
    return plagiarism.identity === identity;
  });
});
var status = function status() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.status;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.PLAGIARISM_SEARCH_COMPLETED:
      return _objectSpread(_objectSpread({}, state), {}, {
        searchBusy: false,
        searchCompleted: true
      });
    case c.PLAGIARISM_SEARCH_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        searchBusy: true
      });
    case c.DOWNLOAD_URL_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        retrievingDownload: true,
        downloadingFiles: [].concat(_toConsumableArray(state.downloadingFiles), [action.plagiarismIdentity])
      });
    case c.DOWNLOAD_URL_REQUEST_COMPLETE:
      return _objectSpread(_objectSpread({}, state), {}, {
        retrievingDownload: false,
        downloadingFiles: state.downloadingFiles.filter(function (id) {
          return id !== action.plagiarismIdentity;
        })
      });
    default:
      return state;
  }
};
var plagiarismList = function plagiarismList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.plagiarisms;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.PLAGIARISM_ARCHIVED:
      return state.filter(function (item) {
        return item.id !== action.plagiarismIdentity;
      });
    case c.PLAGIARISM_SEARCH_COMPLETED:
      return action.plagiarisms || action.data || [];
    case c.PLAGIARISM_UPDATED:
      return state.map(function (plagiarism) {
        return action.plagiarisms[plagiarism.id] || plagiarism;
      });
    default:
      return state;
  }
};
var processingDocuments = function processingDocuments() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.processingDocuments;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.SET_DOCUMENT_PROCESSING:
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.fileIdentity, action.isProcessing));
    case c.CLEAR_ALL_PROCESSING_STATES:
      return {};
    default:
      return state;
  }
};
export var plagiarismReducer = function plagiarismReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.PLAGIARISM_ARCHIVED:
      return _objectSpread(_objectSpread({}, state), {}, {
        plagiarisms: plagiarismList(state.plagiarisms, action)
      });
    case c.PLAGIARISM_SEARCH_COMPLETED:
      return _objectSpread(_objectSpread({}, state), {}, {
        plagiarisms: plagiarismList(state.plagiarisms, action),
        pagination: action.pagination,
        status: status(state.status, action),
        processingDocuments: processingDocuments(state.processingDocuments, action)
      });
    case c.PLAGIARISM_UPDATED:
      return _objectSpread(_objectSpread({}, state), {}, {
        plagiarisms: plagiarismList(state.plagiarisms, action)
      });
    case c.PLAGIARISM_SEARCH_REQUESTED:
    case c.DOWNLOAD_URL_REQUESTED:
    case c.DOWNLOAD_URL_REQUEST_COMPLETE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: status(state.status, action)
      });
    case c.SET_DOCUMENT_PROCESSING:
    case c.CLEAR_ALL_PROCESSING_STATES:
      return _objectSpread(_objectSpread({}, state), {}, {
        processingDocuments: processingDocuments(state.processingDocuments, action)
      });
    case c.PLAGIARISM_DISPLAY_UPDATED:
      return _objectSpread(_objectSpread({}, state), {}, {
        availablePlagiarismPurchases: action.availablePlagiarismPurchases,
        plagiarismPurchase: action.plagiarismPurchase,
        plagiarismPurchases: action.plagiarismPurchases,
        hasPlagiarismPurchase: action.hasPlagiarismPurchase,
        hasUploadedPlagiarism: action.hasUploadedPlagiarism
      });
    default:
      return state;
  }
};
export default plagiarismReducer;